import { handleActions } from 'redux-actions';

const INITIAL_STATE = {
  display_name: '',
  availability: '',
  living_situation: '',
  bio: '',
  pet_insurance: false,
  police_checked: false,
  needs: [],
  interests: [],
  profile_photo: '',
};

/**
 * profile in state
 * Maintains user profile state (human profile)
 */
const profile = handleActions(
  {
    UPDATE_PROFILE: (state, action) => Object.assign({}, state, action.payload),
    ADD_PROFILE_NEED: (state, action) => {
      const inArray = state.needs.find(need => need === action.payload);

      // If the item is not already in the array, add it. Otherwise return state
      return !inArray ? Object.assign({}, state, {
        needs: state.needs.concat([action.payload]),
      }) : state;
    },
    REMOVE_PROFILE_NEED: (state, action) => Object.assign({}, state, {
      needs: state.needs.filter(need => need !== action.payload),
    }),
    ADD_PROFILE_INTEREST: (state, action) => {
      const inArray = state.interests.find(interest => interest === action.payload);

      // If the item is not already in the array, add it. Otherwise return state
      return !inArray ? Object.assign({}, state, {
        interests: state.interests.concat([action.payload]),
      }) : state;
    },
    REMOVE_PROFILE_INTEREST: (state, action) => Object.assign({}, state, {
      interests: state.interests.filter(interest => interest !== action.payload),
    }),
    LOGOUT: state => Object.assign({}, state, INITIAL_STATE),
  },
  INITIAL_STATE,
);

export default profile;



// WEBPACK FOOTER //
// ./src/reducers/profile.js